// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comparative-analysis-container {
  padding: 20px;
  width: 90%;
  margin: 0 auto;
}

.comparative-analysis-container h2 {
  color: #333;
  margin-bottom: 20px;
  font-size: 24px;
}

.no-selection {
  background-color: #f8f9fa;
  border: 2px dashed #dee2e6;
  border-radius: 8px;
  padding: 40px;
  text-align: center;
  color: #6c757d;
}

.no-selection p {
  margin: 10px 0;
  font-size: 16px;
}

.analysis-form {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 20px;
}

.form-section {
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e9ecef;
}

.form-section:last-child {
  border-bottom: none;
}

.form-section h3 {
  color: #495057;
  font-size: 18px;
  margin-bottom: 15px;
}

/* Selected Tests Section */
.selected-tests-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 15px;
}

.test-id-item {
  background-color: #e7f3ff;
  border: 1px solid #b3d9ff;
  border-radius: 4px;
  padding: 8px 12px;
  font-size: 14px;
  color: #004085;
  font-family: monospace;
}

.clear-selection-btn {
  background-color: #6c757d;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.clear-selection-btn:hover {
  background-color: #5a6268;
}

/* Report Name Section */
.report-name-input {
  width: 100%;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  box-sizing: border-box;
}

.report-name-input:focus {
  outline: none;
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.report-name-input:disabled {
  background-color: #e9ecef;
  cursor: not-allowed;
}

/* Parameter Selection Section */
.parameters-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 15px;
}

.parameter-checkbox {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 10px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.parameter-checkbox:hover {
  background-color: #f8f9fa;
}

.parameter-checkbox input[type="checkbox"] {
  width: 18px;
  height: 18px;
  margin-right: 10px;
  cursor: pointer;
}

.parameter-checkbox input[type="checkbox"]:disabled {
  cursor: not-allowed;
}

.parameter-checkbox span {
  font-size: 15px;
  color: #495057;
}

/* Submit Button */
.submit-btn {
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  width: 100%;
  max-width: 300px;
}

.submit-btn:hover:not(:disabled) {
  background-color: #0056b3;
}

.submit-btn:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

/* Status Message */
.status-message {
  margin-top: 20px;
  padding: 12px;
  border-radius: 4px;
  font-size: 14px;
}

.status-message.success {
  background-color: #d4edda;
  border: 1px solid #c3e6cb;
  color: #155724;
}

.status-message.error {
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  color: #721c24;
}

/* Reports Section */
.reports-section {
  margin-bottom: 40px;
}

.reports-section h3 {
  color: #495057;
  font-size: 20px;
  margin-bottom: 15px;
}

.section-title {
  color: #495057;
  font-size: 20px;
  margin: 30px 0 15px 0;
  padding-top: 20px;
  border-top: 2px solid #dee2e6;
}

.no-reports {
  padding: 20px;
  text-align: center;
  color: #6c757d;
  background-color: #f8f9fa;
  border-radius: 4px;
  font-style: italic;
}

.table-container {
  overflow-x: auto;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.reports-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.reports-table thead {
  background-color: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
}

.reports-table th {
  padding: 12px 15px;
  text-align: left;
  font-weight: 600;
  color: #495057;
  white-space: nowrap;
}

.reports-table tbody tr {
  border-bottom: 1px solid #e9ecef;
  transition: background-color 0.2s;
}

.reports-table tbody tr:hover {
  background-color: #f8f9fa;
}

.reports-table td {
  padding: 12px 15px;
}

.report-id {
  font-family: monospace;
  font-size: 12px;
  color: #495057;
}

.created-by {
  font-size: 13px;
  color: #495057;
  font-weight: 500;
}

.text-center {
  text-align: center;
}

.parameters {
  font-size: 12px;
  color: #6c757d;
}

.status-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.status-pending {
  background-color: #fff3cd;
  color: #856404;
  border: 1px solid #ffeeba;
}

.status-completed {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.status-failed {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.view-report-btn {
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 13px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.view-report-btn:hover {
  background-color: #0056b3;
}

.rerun-report-btn {
  background-color: #6c757d;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 13px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.rerun-report-btn:hover {
  background-color: #5a6268;
}

.delete-report-btn {
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 13px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.delete-report-btn:hover {
  background-color: #c82333;
}

/* Test Selection Section */
.test-selection-section {
  margin-bottom: 40px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 20px;
}

.test-selection-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.test-selection-table thead {
  background-color: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
}

.test-selection-table th {
  padding: 12px 15px;
  text-align: left;
  font-weight: 600;
  color: #495057;
  white-space: nowrap;
}

.test-selection-table tbody tr {
  border-bottom: 1px solid #e9ecef;
  transition: background-color 0.2s;
}

.test-selection-table tbody tr:hover {
  background-color: #f8f9fa;
}

.test-selection-table td {
  padding: 12px 15px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .comparative-analysis-container {
    padding: 10px;
  }

  .parameters-grid {
    grid-template-columns: 1fr;
  }

  .submit-btn {
    max-width: 100%;
  }

  .reports-table {
    font-size: 12px;
  }

  .reports-table th,
  .reports-table td {
    padding: 8px 10px;
  }

  .test-selection-table {
    font-size: 12px;
  }

  .test-selection-table th,
  .test-selection-table td {
    padding: 8px 10px;
  }
}

/* Bulk rerun bar */
.bulk-rerun-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 6px;
  padding: 10px 14px;
  margin-bottom: 10px;
  font-size: 14px;
  color: #343a40;
}

.bulk-rerun-btn {
  background-color: #6c757d;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 6px 14px;
  font-size: 13px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.bulk-rerun-btn:hover {
  background-color: #5a6268;
}

/* Rerun modal */
.rerun-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.rerun-modal {
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  width: 560px;
  max-width: 90vw;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}

.rerun-modal h3 {
  margin: 0;
  font-size: 18px;
  color: #212529;
}

.rerun-modal-subtitle {
  margin: 0;
  font-size: 13px;
  color: #6c757d;
}

.rerun-mode-options {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.rerun-mode-btn {
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: baseline;
  column-gap: 10px;
  row-gap: 4px;
  background-color: #f8f9fa;
  color: #212529;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 12px 16px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s, border-color 0.2s;
  text-align: left;
}

.rerun-mode-btn:hover {
  background-color: #e9ecef;
  border-color: #6c757d;
}

.rerun-mode-btn input[type="radio"] {
  cursor: pointer;
  width: 16px;
  height: 16px;
}

.rerun-mode-desc {
  grid-column: 2;
  font-size: 12px;
  font-weight: 400;
  color: #6c757d;
}

.rerun-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding-top: 4px;
  border-top: 1px solid #dee2e6;
}

.rerun-modal-cancel-btn {
  background-color: #fff;
  color: #6c757d;
  border: 1px solid #6c757d;
  border-radius: 4px;
  padding: 7px 16px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.rerun-modal-cancel-btn:hover {
  background-color: #f8f9fa;
}

.rerun-modal-confirm-btn {
  background-color: #6c757d;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 7px 16px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.rerun-modal-confirm-btn:hover {
  background-color: #5a6268;
}
`, "",{"version":3,"sources":["webpack://./src/ComparativeAnalysis.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;EACnB;AACF;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oDAAoD;EACpD,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".comparative-analysis-container {\n  padding: 20px;\n  width: 90%;\n  margin: 0 auto;\n}\n\n.comparative-analysis-container h2 {\n  color: #333;\n  margin-bottom: 20px;\n  font-size: 24px;\n}\n\n.no-selection {\n  background-color: #f8f9fa;\n  border: 2px dashed #dee2e6;\n  border-radius: 8px;\n  padding: 40px;\n  text-align: center;\n  color: #6c757d;\n}\n\n.no-selection p {\n  margin: 10px 0;\n  font-size: 16px;\n}\n\n.analysis-form {\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n}\n\n.form-section {\n  margin-bottom: 30px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.form-section:last-child {\n  border-bottom: none;\n}\n\n.form-section h3 {\n  color: #495057;\n  font-size: 18px;\n  margin-bottom: 15px;\n}\n\n/* Selected Tests Section */\n.selected-tests-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-bottom: 15px;\n}\n\n.test-id-item {\n  background-color: #e7f3ff;\n  border: 1px solid #b3d9ff;\n  border-radius: 4px;\n  padding: 8px 12px;\n  font-size: 14px;\n  color: #004085;\n  font-family: monospace;\n}\n\n.clear-selection-btn {\n  background-color: #6c757d;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 8px 16px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.clear-selection-btn:hover {\n  background-color: #5a6268;\n}\n\n/* Report Name Section */\n.report-name-input {\n  width: 100%;\n  padding: 10px;\n  font-size: 16px;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  box-sizing: border-box;\n}\n\n.report-name-input:focus {\n  outline: none;\n  border-color: #80bdff;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n.report-name-input:disabled {\n  background-color: #e9ecef;\n  cursor: not-allowed;\n}\n\n/* Parameter Selection Section */\n.parameters-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n  gap: 15px;\n}\n\n.parameter-checkbox {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  padding: 10px;\n  border-radius: 4px;\n  transition: background-color 0.2s;\n}\n\n.parameter-checkbox:hover {\n  background-color: #f8f9fa;\n}\n\n.parameter-checkbox input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  margin-right: 10px;\n  cursor: pointer;\n}\n\n.parameter-checkbox input[type=\"checkbox\"]:disabled {\n  cursor: not-allowed;\n}\n\n.parameter-checkbox span {\n  font-size: 15px;\n  color: #495057;\n}\n\n/* Submit Button */\n.submit-btn {\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 12px 24px;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  width: 100%;\n  max-width: 300px;\n}\n\n.submit-btn:hover:not(:disabled) {\n  background-color: #0056b3;\n}\n\n.submit-btn:disabled {\n  background-color: #6c757d;\n  cursor: not-allowed;\n}\n\n/* Status Message */\n.status-message {\n  margin-top: 20px;\n  padding: 12px;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.status-message.success {\n  background-color: #d4edda;\n  border: 1px solid #c3e6cb;\n  color: #155724;\n}\n\n.status-message.error {\n  background-color: #f8d7da;\n  border: 1px solid #f5c6cb;\n  color: #721c24;\n}\n\n/* Reports Section */\n.reports-section {\n  margin-bottom: 40px;\n}\n\n.reports-section h3 {\n  color: #495057;\n  font-size: 20px;\n  margin-bottom: 15px;\n}\n\n.section-title {\n  color: #495057;\n  font-size: 20px;\n  margin: 30px 0 15px 0;\n  padding-top: 20px;\n  border-top: 2px solid #dee2e6;\n}\n\n.no-reports {\n  padding: 20px;\n  text-align: center;\n  color: #6c757d;\n  background-color: #f8f9fa;\n  border-radius: 4px;\n  font-style: italic;\n}\n\n.table-container {\n  overflow-x: auto;\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.reports-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.reports-table thead {\n  background-color: #f8f9fa;\n  border-bottom: 2px solid #dee2e6;\n}\n\n.reports-table th {\n  padding: 12px 15px;\n  text-align: left;\n  font-weight: 600;\n  color: #495057;\n  white-space: nowrap;\n}\n\n.reports-table tbody tr {\n  border-bottom: 1px solid #e9ecef;\n  transition: background-color 0.2s;\n}\n\n.reports-table tbody tr:hover {\n  background-color: #f8f9fa;\n}\n\n.reports-table td {\n  padding: 12px 15px;\n}\n\n.report-id {\n  font-family: monospace;\n  font-size: 12px;\n  color: #495057;\n}\n\n.created-by {\n  font-size: 13px;\n  color: #495057;\n  font-weight: 500;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.parameters {\n  font-size: 12px;\n  color: #6c757d;\n}\n\n.status-badge {\n  display: inline-block;\n  padding: 4px 10px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.status-pending {\n  background-color: #fff3cd;\n  color: #856404;\n  border: 1px solid #ffeeba;\n}\n\n.status-completed {\n  background-color: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n}\n\n.status-failed {\n  background-color: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n}\n\n.view-report-btn {\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 6px 12px;\n  font-size: 13px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.view-report-btn:hover {\n  background-color: #0056b3;\n}\n\n.rerun-report-btn {\n  background-color: #6c757d;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 6px 12px;\n  font-size: 13px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.rerun-report-btn:hover {\n  background-color: #5a6268;\n}\n\n.delete-report-btn {\n  background-color: #dc3545;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 6px 12px;\n  font-size: 13px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.delete-report-btn:hover {\n  background-color: #c82333;\n}\n\n/* Test Selection Section */\n.test-selection-section {\n  margin-bottom: 40px;\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n}\n\n.test-selection-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.test-selection-table thead {\n  background-color: #f8f9fa;\n  border-bottom: 2px solid #dee2e6;\n}\n\n.test-selection-table th {\n  padding: 12px 15px;\n  text-align: left;\n  font-weight: 600;\n  color: #495057;\n  white-space: nowrap;\n}\n\n.test-selection-table tbody tr {\n  border-bottom: 1px solid #e9ecef;\n  transition: background-color 0.2s;\n}\n\n.test-selection-table tbody tr:hover {\n  background-color: #f8f9fa;\n}\n\n.test-selection-table td {\n  padding: 12px 15px;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .comparative-analysis-container {\n    padding: 10px;\n  }\n\n  .parameters-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .submit-btn {\n    max-width: 100%;\n  }\n\n  .reports-table {\n    font-size: 12px;\n  }\n\n  .reports-table th,\n  .reports-table td {\n    padding: 8px 10px;\n  }\n\n  .test-selection-table {\n    font-size: 12px;\n  }\n\n  .test-selection-table th,\n  .test-selection-table td {\n    padding: 8px 10px;\n  }\n}\n\n/* Bulk rerun bar */\n.bulk-rerun-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: #e9ecef;\n  border: 1px solid #ced4da;\n  border-radius: 6px;\n  padding: 10px 14px;\n  margin-bottom: 10px;\n  font-size: 14px;\n  color: #343a40;\n}\n\n.bulk-rerun-btn {\n  background-color: #6c757d;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 6px 14px;\n  font-size: 13px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.bulk-rerun-btn:hover {\n  background-color: #5a6268;\n}\n\n/* Rerun modal */\n.rerun-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.rerun-modal {\n  background: #fff;\n  border-radius: 8px;\n  padding: 24px;\n  width: 560px;\n  max-width: 90vw;\n  max-height: 80vh;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\n}\n\n.rerun-modal h3 {\n  margin: 0;\n  font-size: 18px;\n  color: #212529;\n}\n\n.rerun-modal-subtitle {\n  margin: 0;\n  font-size: 13px;\n  color: #6c757d;\n}\n\n.rerun-mode-options {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.rerun-mode-btn {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  align-items: baseline;\n  column-gap: 10px;\n  row-gap: 4px;\n  background-color: #f8f9fa;\n  color: #212529;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  padding: 12px 16px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s, border-color 0.2s;\n  text-align: left;\n}\n\n.rerun-mode-btn:hover {\n  background-color: #e9ecef;\n  border-color: #6c757d;\n}\n\n.rerun-mode-btn input[type=\"radio\"] {\n  cursor: pointer;\n  width: 16px;\n  height: 16px;\n}\n\n.rerun-mode-desc {\n  grid-column: 2;\n  font-size: 12px;\n  font-weight: 400;\n  color: #6c757d;\n}\n\n.rerun-modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding-top: 4px;\n  border-top: 1px solid #dee2e6;\n}\n\n.rerun-modal-cancel-btn {\n  background-color: #fff;\n  color: #6c757d;\n  border: 1px solid #6c757d;\n  border-radius: 4px;\n  padding: 7px 16px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.rerun-modal-cancel-btn:hover {\n  background-color: #f8f9fa;\n}\n\n.rerun-modal-confirm-btn {\n  background-color: #6c757d;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 7px 16px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.rerun-modal-confirm-btn:hover {\n  background-color: #5a6268;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
